// extracted by mini-css-extract-plugin
export var loadingSpinner = "_2d-0";
export var spinnerContainer = "_2d-1";